module.exports = __webpack_public_path__ + "img/hoehe.bed06ff2.svg";